<template>
  <div>

    <van-nav-bar title="个人信息设置" fixed="fixed">
      <template #left>
        <div @click="back" class="backButton">
          <svg-icon icon-class="backButton" style="width:12px;height:20px;"></svg-icon>
        </div>
      </template>
    </van-nav-bar>


    <div style="padding-top: 46px;">

      <div class="headImgBox van-hairline--bottom">
        <div class="uploader" @click="clickInput">
          <img :src="headImage" id="img">
          <svg-icon icon-class="hPBG" style="height: 73px;width: 73px;position: absolute;left: -1px;top: -1px"
                    v-if="headImage===''"></svg-icon>
          <input type="file" id="input" ref="input" name="fileId" accept="image/png,image/jpeg,image/gif"
                 @change="cut($event)">
        </div>
      </div>


      <div class="option van-hairline--bottom" @click="setName=true">
        <div class="opTitle">用户昵称</div>
        <div class="opContent">{{ name }}</div>
      </div>
      <div class="option van-hairline--bottom" @click="setSex=true">
        <div class="opTitle">性别</div>
        <div class="opContent">{{ sex == 1 ? '男' : '女' }}</div>
      </div>
      <div class="option van-hairline--bottom" @click="setArea=true">
        <div class="opTitle">所在地</div>
        <div class="opContent">
          <div class="county">{{ county }}</div>
          <div class="city">{{ city }}</div>
        </div>
      </div>


      <van-popup v-model="setName" round>
        <div class="setNameBox">

          <div class="setNameMainBox van-hairline--bottom">
            <div class="setNameTitle">用户昵称</div>
            <div class="setNameInput">
              <van-field v-model="nameText" placeholder="最多六个字"/>
            </div>
          </div>

          <div class="setNameCancel" @click="cancelName">取消</div>
          <div class="setNameConfirm" @click="confirmName">确认</div>

        </div>
      </van-popup>


      <van-popup v-model="setSex" round position="bottom" :style="{ height: '308px' }">
        <van-picker show-toolbar title="选择性别" :columns="sexList" :default-index="sex == 1? 0:1" @confirm="confirmSex"
                    @cancel="cancelSex"/>
      </van-popup>


      <van-popup v-model="setArea" round position="bottom" :style="{ height: '308px' }">
        <van-area title="城市选择" :area-list="areaList" :columns-num="2" @confirm="confirmArea"
                  @cancel="cancelArea" :value="cityId"/>
      </van-popup>


    </div>




  </div>
</template>

<script>
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  name: "modify",
  data() {
    return {
      headImage: '',
      name: '',
      sex: 0,
      countyId: 0,
      cityId: 0,
      county: '',
      city: '',
      nameText: '',
      pattern: /^\S{1,6}$/,
      sexList: ['男', '女'],
      areaList: {
        province_list: {},
        city_list: {}
      },
      setName: false,
      setSex: false,
      setArea: false,


    }
  },
  methods: {
    clickInput() {
      this.$refs.input.click()
    },
    cut(e) {
      this.$store.state.headImg = window.URL.createObjectURL(e.target.files[0])
      this.$router.push('/cut')
    },


    getAera() {
      this.$post(this.$store.state.apiUrl + '/sys/get_area_all', {qdata: this.$encrypt(this.$genQuery({}))}).then(res => {

        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            this.areaList.province_list[res.data[i].id] = res.data[i].name
            for (let j = 0; j < res.data[i].childs.length; j++) {
              this.areaList.city_list[res.data[i].childs[j].id] = res.data[i].childs[j].name
            }
          }

          this.$forceUpdate()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getUserData() {
      this.name = localStorage.getItem('nickName')
      this.sex = localStorage.getItem('sex')
      this.countyId = localStorage.getItem('province_id')
      this.cityId = localStorage.getItem('city_id')
      this.county = localStorage.getItem('province')
      this.city = localStorage.getItem('city')
      this.headImage = localStorage.getItem('headImg') || ''
    },
    confirmName() {
      let nameCheck = this.nameText.search(this.pattern)
      if (nameCheck === 0) {

        let query = this.$encrypt(this.$genQuery({nick_name: this.nameText}))
        this.$post(this.$store.state.apiUrl + '/member/set_nickname', {qdata: query}).then(res => {

          if (res.status === 0) {
            localStorage.setItem('nickName', this.nameText)
            this.getUserData()
            this.setName = false
            this.nameText = ''
            this.$toast(res.msg);
          } else {
            this.$toast(res.msg);
          }
        }).catch(err => {
          console.log(err)
        })


      } else {
        this.$toast('必须为1-6个字');
      }
    },
    cancelName() {
      this.setName = false
    },
    confirmSex(data, index) {
      let sex = index === 0 ? 1 : 2
      let query = this.$encrypt(this.$genQuery({sex}))
      this.$post(this.$store.state.apiUrl + '/member/set_sex', {qdata: query}).then(res => {
        if (res.status === 0) {
          localStorage.setItem('sex', sex)
          this.getUserData()
          this.setSex = false
          this.$toast(res.msg);
        } else {
          this.$toast(res.msg);
        }
      }).catch(err => {
        console.log(err)
      })
    },

    cancelSex() {
      this.setSex = false
    },


    confirmArea(data) {
      let province_id = data[0].code
      let city_id = data[1].code
      let query = this.$encrypt(this.$genQuery({province_id, city_id}))
      this.$post(this.$store.state.apiUrl + '/member/set_provincecity', {qdata: query}).then(res => {
        if (res.status === 0) {
          localStorage.setItem('province_id', province_id)
          localStorage.setItem('city_id', city_id)
          localStorage.setItem('province', this.areaList.province_list[province_id])
          localStorage.setItem('city', this.areaList.city_list[city_id])
          this.getUserData()
          this.setArea = false
          this.$toast(res.msg);
        } else {
          this.$toast(res.msg);
        }
      }).catch(err => {
        console.log(err)
      })
    },
    cancelArea() {
      this.setArea = false
    },
    back(){
      this.$router.push('/userCenter')
    }

  },
  mounted() {
    this.getAera()
    this.getUserData()
  },

}
</script>

<style scoped>
.uploader {
  position: relative;
  text-align: center;
  height: 72px;
  width: 72px;
  margin: 0 auto;

}

#img {
  height: 72px;
  width: 72px;

  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
}

#input {
  display: none;
}


.headImgBox {
  height: 135px;
  width: 100%;
  display: flex;
  align-items: center;
  border: 0;
}

.option {
  height: 50px;
  width: 100%;
  /*padding-left: 16px;*/
  /*padding-right: 16px;*/
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
}

.opTitle {
  position: absolute;
  left: 16px;
  color: #585e6a;
  font-size: 17px;
}

.opContent {
  position: absolute;
  left: 110px;
  color: #323440;
  font-size: 17px;
  display: flex;
}

.county {

}

.city {
  margin-left: 10px;
}

.setNameBox {
  width: 300px;
  height: 140px;
  position: relative;

}

.setNameMainBox {
  width: 100%;
  height: 90px;
  position: relative;
  display: flex;
  justify-content: center;
}

.setNameTitle {
  color: #585e6a;
  font-size: 14px;
  position: absolute;
  top: 10px;
}

.setNameInput {
  position: absolute;
  top: 40px;
  width: 100%;

}

.setNameCancel {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 50px;
  width: 50%;
  color: #585e6a;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.setNameConfirm {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 50px;
  width: 50%;
  color: #5f7299;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>

